import { Box, FormControl, IconButton, InputLabel, MenuItem, Select, TextField, Typography } from '@mui/material'
import RegularButton from 'components/CustomButtons/Button'
import { useForm } from 'hooks/useForm'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Snackbars from "components/Snackbar/Snackbar.js";
import { 
  deleteTabulator,
  createNewTabulator,
  editTabulator
} from 'redux/actions/tabulatorsCatalog/tabulatorsCatalogActions.js'
import { generateRandomID } from 'helpers/generateRandomID'
import { FormRangesEdit } from './FormRangesEdit'
import Clear from '@mui/icons-material/Clear'

const blue = '#0055aa'

export const FormTabulatorEdit = (props) => {
  const { rulesCombinations, rulesKeysOptions, handleClose } = props
  const { tabulatorSelected, addMode, deleteMode } = useSelector(state => state.tabulatorsCatalog)
  const { contractsArr, activeContractVariantsArr, contractSelected, contractVariantSelected } = useSelector(state => state.contractsCatalog)
  const { stationsSelected } = useSelector((state) => state.search);
  const { stationsList } = useSelector(state => state.companies);
  const [snackBar, setSnackBar] = useState({ msg: "", isOpen: false })
  const [rules, setRules] = useState({})
  const [validRulesKeysOptions, setValidRulesKeysOptions] = useState(rulesKeysOptions)
  const [ranges, setRanges] = useState([{ id: generateRandomID(32), min: 0, max: 0, price: 0 }])
  const { token } = useSelector(state => state.login)
  const { inputValues, handleInputOnChange, handleNewValues } = useForm({
    name: '',
    idStation: '', 
    idContract: '',
    idContractVariant: ''
  })
  const { name, idStation, idContract, idContractVariant } = inputValues
  const dispatch = useDispatch()

  const handleRuleOnChange = ({target}) => {
    const {name, value} = target
    const newRules = {...rules, [name]: value}
    setRules(newRules)

    let validCombinations = rulesCombinations
    let minRule = null
    Object.keys(newRules).map(idRule => {
      if (newRules[idRule]) {
        const ruleCombinations = rulesCombinations.filter(combination => combination.includes(newRules[idRule]))
        if(!minRule) {
          validCombinations = ruleCombinations
          minRule = {id: idRule, length: ruleCombinations.length}
        }
        if(ruleCombinations.length < minRule.length) {
          validCombinations = ruleCombinations
          minRule = {id: idRule, length: ruleCombinations.length}
        }
      }
    })

    setValidRulesKeysOptions(rulesKeysOptions.map(rule => {
      if(minRule && rule.id === minRule.id) return { 
        ...rule,
        ruleKeys: rule.ruleKeys.filter(ruleKey => rulesCombinations.filter(ruleCombination => ruleCombination.includes(ruleKey.idRuleKey)).length)
      }
      else return {
        ...rule,
        ruleKeys: rule.ruleKeys.filter(ruleKey => validCombinations.filter(ruleCombination => ruleCombination.includes(ruleKey.idRuleKey)).length)
      }
    }))
  }

  const handleSubmit = () => {
    if(deleteMode){
      dispatch(deleteTabulator(tabulatorSelected.id, token))
      handleClose()
      return
    } 

    const newValues = {
      ...tabulatorSelected,
      name,
      idStation,
      idContract,
      idContractVariant,
      idGroups: Object.keys(rules).filter(rule => !rules[rule].includes('NO_APLICA')).map(rule => rules[rule]),
      ranges: ranges.map(range => ({min: range.min, max: range.max, price: range.price}))
    }

    if(name && idStation && idContract && idContractVariant) {
      if(addMode){
        dispatch(createNewTabulator(newValues, token))
        handleClose()
      } else {
        dispatch(editTabulator(tabulatorSelected.id, newValues, token))
        handleClose()
      }
    } else {
      setSnackBar({ msg: "Campos con * son requeridos", isOpen: true })
    }
  }

  useEffect(() => {
    let newInputValues = {...inputValues}
    if (stationsSelected?.id) newInputValues = { ...newInputValues, idStation: stationsSelected.id}
    if (contractSelected?.id) newInputValues = { ...newInputValues, idContract: contractSelected.id}
    if (contractVariantSelected?.id) newInputValues = { ...newInputValues, idContractVariant: contractVariantSelected.id}

    if (tabulatorSelected) {
      newInputValues = {
        ...newInputValues,
        name: tabulatorSelected.name,
        idContractVariant: tabulatorSelected.idContractVariant
      }
      setRanges(tabulatorSelected?.ranges?.map(range => ({id: generateRandomID(32), ...range})))
    }
    handleNewValues(newInputValues)
    // eslint-disable-next-line 
  }, [tabulatorSelected, stationsSelected, contractSelected, contractVariantSelected])

  useEffect(() => {
    if(rulesKeysOptions.length) {
      let newRules = {}
      rulesKeysOptions.forEach(rule => {
        newRules = {
          ...newRules, 
          [rule.id]: tabulatorSelected && ( tabulatorSelected[rule.id]?.id || '' )
        }
      })
      setRules(newRules)
    }
    setValidRulesKeysOptions(rulesKeysOptions.map(rule => ({
      ...rule,
      ruleKeys: rule.ruleKeys.filter(ruleKey => rulesCombinations.find(ruleCombination => ruleCombination.includes(ruleKey.idRuleKey)))
    })))
    // eslint-disable-next-line 
  }, [rulesKeysOptions])

  return (
    <>
      <FormControl fullWidth style={{ display: 'flex', gap: 10, marginTop: 20, alignItems: 'center' }} onSubmit={handleSubmit}>
        <FormControl fullWidth variant="outlined">
          <InputLabel>Planta *</InputLabel>
          <Select
            name="idStation"
            value={idStation}
            onChange={e => handleInputOnChange(e)}
            label="Planta *"
            disabled={deleteMode || ( !deleteMode && !addMode ) || stationsSelected?.id}
          > 
            { stationsList.map(item => <MenuItem key={item.value} value={item.value}>{item.label}</MenuItem>) }
          </Select>
        </FormControl>
        <FormControl fullWidth variant="outlined">
          <InputLabel>Contrato *</InputLabel>
          <Select
            name="idContract"
            value={idContract}
            onChange={e => handleInputOnChange(e)}
            label="Contrato *"
            disabled={deleteMode || ( !deleteMode && !addMode ) || contractSelected?.id}
          > 
            { contractsArr.map(item => <MenuItem key={item.value} value={item.value}>{item.name}</MenuItem>) }
          </Select>
        </FormControl>
        <FormControl fullWidth variant="outlined">
          <InputLabel>Variante de Contrato *</InputLabel>
          <Select
            name="idContractVariant"
            value={idContractVariant}
            onChange={e => handleInputOnChange(e)}
            label="Variante de Contrato *"
            disabled={deleteMode || ( !deleteMode && !addMode ) || (contractVariantSelected?.id && !tabulatorSelected?.idContractVariant)}
          > 
            { activeContractVariantsArr.map(item => <MenuItem key={item.value} value={item.value}>{`${item.job} ${item.unitType}`}</MenuItem>) }
          </Select>
        </FormControl>
        <TextField fullWidth type="text" label="Nombre *" name="name" value={name} disabled={deleteMode} onChange={handleInputOnChange} variant="outlined"/>
        {
          rulesKeysOptions.length > 0 && Object.keys(rules).length > 0 &&
            <>
              <Typography style={{ alignSelf: 'start', marginTop: 30 }}>Reglas</Typography>
              {
                validRulesKeysOptions.map(rule => (   
                  <FormControl fullWidth key={rule.id} variant="outlined">
                    <InputLabel>{`${rule.name} *`}</InputLabel>
                    <Select
                      name={rule.id}
                      value={rules[rule.id]}
                      onChange={e => handleRuleOnChange(e)}
                      label={`${rule.name} *`}
                      disabled={deleteMode}
                      endAdornment={
                        <IconButton onClick={() => handleRuleOnChange({target: {name: rule.id, value: null}})}>
                            <Clear />
                        </IconButton>
                      }
                    > 
                      { [...rule.ruleKeys, ...(
                        tabulatorSelected 
                          ? [{
                              idRuleKey: tabulatorSelected[rule.id]?.id,
                              value: tabulatorSelected[rule.id]?.value
                            }]
                          : []
                      )].filter((value, index, self) => index === self.findIndex((item) => item.idRuleKey === value.idRuleKey))
                        .map(item => <MenuItem key={item.idRuleKey} value={item.idRuleKey}>{item.value}</MenuItem>) }
                    </Select>
                  </FormControl>
                ))
              }
            </>
        }
        <FormRangesEdit setRanges={setRanges} ranges={ranges}/>
        <Box style={{display: 'flex', justifyContent: 'space-between', marginTop: 30, width: '100%'}}>
          <RegularButton variant="contained" color="danger" onClick={handleClose}>Cancelar</RegularButton>
          <RegularButton 
            variant="contained" 
            color="facebook"
            style={{backgroundColor: blue, color: 'white'}} 
            onClick={handleSubmit}
            disabled={!(name && idStation && idContract && idContractVariant)}
          >
            { 
              addMode 
                ? 'Agregar' 
                : deleteMode ? 'Eliminar' 
                : 'Guardar'
            }
          </RegularButton>
        </Box>
      </FormControl>
      <Snackbars
          place="tr"
          color='danger'
          message={snackBar.msg}
          open={snackBar.isOpen}
          closeNotification={() => setSnackBar({ msg: "", isOpen: false })}
          close
      /> 
    </>
  )
}
